var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{},[_c('preview',{ref:"preview"}),_c('div',{staticClass:"sharelist",style:({height:_vm.tableHeight+'px'})},_vm._l((_vm.shareList),function(item,index){return _c('share-card',{key:item.id,attrs:{"shareitem":item}})}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }